// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__2G3qS","skeleton_user":"Skeleton_skeleton_user__EO73Q","img":"Skeleton_img__25-ZS","content":"Skeleton_content__1EQBd"};